import { sub, dot, cross, norm } from "./vec3";

// Rendering only: clip the part of an occluder that lies in front of the
// receiving plane along the orthographic camera ray. Centroid sorting alone
// cannot order a long PV row against a nearby tree/building correctly.
export function frontOccluder(receiver, blocker, cameraDirection) {
  const normal = norm(cross(sub(receiver[1], receiver[0]), sub(receiver[2], receiver[0])));
  const denominator = dot(normal, cameraDirection);
  if (Math.abs(denominator) < 1e-9) return [];
  const distance = p => dot(sub(p, receiver[0]), normal) / denominator;
  const distances = blocker.map(distance);
  const epsilon = 1e-4; // Float32 meshes may differ slightly from their source.
  if (distances.every(d => d <= epsilon)) return [];
  const output = [];
  blocker.forEach((current, i) => {
    const j = (i + blocker.length - 1) % blocker.length;
    const previous = blocker[j], a = distances[j], b = distances[i];
    if ((a > epsilon) !== (b > epsilon)) {
      const t = (epsilon - a) / (b - a);
      output.push({ x: previous.x + t * (current.x - previous.x),
        y: previous.y + t * (current.y - previous.y), z: previous.z + t * (current.z - previous.z) });
    }
    if (b > epsilon) output.push(current);
  });
  return output.length >= 3 ? output : [];
}

export function screenBounds(points) {
  return { left: Math.min(...points.map(p => p.x)), right: Math.max(...points.map(p => p.x)),
    top: Math.min(...points.map(p => p.y)), bottom: Math.max(...points.map(p => p.y)) };
}
export function boundsOverlap(a, b) {
  return a.left < b.right && b.left < a.right && a.top < b.bottom && b.top < a.bottom;
}
